import React from 'react';
import { Loader2 } from 'lucide-react';
import { LoadingState } from '@/components/ui/loading-state';

interface LoadingOverlayProps {
  isVisible: boolean;
  message?: string;
}

export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ 
  isVisible, 
  message = "Navigating..." 
}) => {
  if (!isVisible) return null;

  return (
    <div 
      className="fixed inset-0 z-50 bg-background/80 backdrop-blur-sm flex items-center justify-center"
      role="alertdialog"
      aria-live="polite"
      aria-busy="true"
    >
      <div className="bg-card p-8 rounded-lg shadow-xl border border-border">
        <LoadingState variant="spinner" message={message} />
      </div>
    </div>
  );
};